module.exports = __webpack_public_path__ + "static/media/ManagementLetters.94e564ab.pdf";